import { Component, ViewChild } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import Swal from 'sweetalert2';
import { NgxCustomModalComponent } from 'ngx-custom-modal';
import { FormBuilder, FormGroup } from '@angular/forms';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import esLocale from '@fullcalendar/core/locales/es';
import { Store } from '@ngrx/store';
import { CalendarService } from './calendar.service';
// import { CiteDTO } from '../../shared/dto/cite.dto';
import { Router } from '@angular/router';

@Component({
  templateUrl: './calendar.html',
  animations: [toggleAnimation],
  styleUrl: './calendar.css',
})
export class CalendarComponent {
  store: any;
  isLoading = true;
  @ViewChild('isAddEventModal') isAddEventModal!: NgxCustomModalComponent;
  @ViewChild('calendar') calendar!: FullCalendarComponent;
  defaultParams = {
    id: null,
  };
  params!: FormGroup;
  isDarkMode = false;
  events: any = [];
  calendarOptions: any;

  constructor(
    public fb: FormBuilder,
    public storeData: Store<any>,
    private calendarService: CalendarService,
    private router: Router,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
    this.initStore();
    this.isLoading = false;
  }
  async initStore() {
    this.storeData
      .select((d: any) => d.index)
      .subscribe((d: any) => {
        const hasChangeLayout = this.store?.layout !== d?.layout;

        const hasChangeMenu = this.store?.menu !== d?.menu;
        const hasChangeSidebar = this.store?.sidebar !== d?.sidebar;

        this.store = d;

        if (hasChangeLayout || hasChangeMenu || hasChangeSidebar) {
          if (this.isLoading) {
            this.initCalendar();
            this.calendarOptions.events = [];
          } else {
            setTimeout(() => {
              this.initCalendar();
            }, 300);
          }
        }
      });
  }

  initCalendar() {
    this.calendarOptions = {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      locale: esLocale,
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay',
        icon: '../../../../assets/images/icon1.png',
      },
      editable: true,
      dayMaxEvents: true,
      selectable: true,
      droppable: true,
    };
  }

  ngOnInit() {
    this.getEvents();
  }

  initForm() {
    this.params = this.fb.group({
      id: [null],
    });
  }

  async getEvents() {
    try {
      const cites = await this.calendarService.getCites();

      // Array para almacenar eventos válidos
      const validEvents = [];

      // Procesar cada cita
      for (const cite of cites) {
        try {
          if (!cite.date || !cite.hour) {
            console.warn('Cita sin fecha u hora:', cite);
            continue;
          }

          // Convertir la fecha y hora a un formato que FullCalendar pueda entender
          const dateParts = cite.date.split('-');
          if (dateParts.length !== 3) {
            console.warn('Formato de fecha inválido:', cite.date);
            continue;
          }

          const year = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const day = parseInt(dateParts[2]);

          const hourParts = cite.hour.split(':');
          if (hourParts.length !== 2) {
            console.warn('Formato de hora inválido:', cite.hour);
            continue;
          }

          const hours = parseInt(hourParts[0]);
          const minutes = parseInt(hourParts[1]);

          // Validar que los valores sean números válidos
          if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hours) || isNaN(minutes)) {
            console.warn('Valores de fecha u hora no numéricos:', { date: cite.date, hour: cite.hour });
            continue;
          }

          // Crear la fecha usando Date.UTC para evitar problemas de zona horaria
          const dateTime = new Date(Date.UTC(year, month - 1, day));
          dateTime.setUTCHours(hours, minutes, 0, 0);

          // Verificar que la fecha sea válida
          if (isNaN(dateTime.getTime())) {
            console.warn('Fecha inválida creada:', dateTime);
            continue;
          }

          // Crear el evento y agregarlo al array
          validEvents.push({
            id: cite.workshop.workShopId,
            title: `${cite.workshop.workShopName} - ${cite.vehicle.plate}`,
            start: dateTime.toISOString(),
            end: dateTime.toISOString(),
            className: 'primary',
            description: cite.description,
            extendedProps: {
              workshop: cite.workshop,
              user: cite.user,
              description: cite.description,
              vehicle: cite.vehicle,
            },
          });
        } catch (itemError) {
          console.error('Error al procesar cita individual:', itemError, cite);
          // Continuar con la siguiente cita
        }
      }

      // Asignar los eventos válidos al calendario
      this.events = validEvents;
      this.calendarOptions.events = this.events;
    } catch (error) {
      console.error('Error al obtener las citas:', error);
      this.showMessage('Error al cargar las citas', 'error');
    }
  }

  getMonth(dt: Date, add: number = 0) {
    const month = dt.getMonth() + 1 + add;
    const str = (month < 10 ? '0' + month : month).toString();
    return str;
  }

  getEventById(id: string | number | null): any {
    if (!id) return null;
    return this.events.find((event: any) => event.id === id);
  }

  goToAssistant() {
    this.router.navigate(['/assistant']);
  }

  showMessage(msg = '', type = 'success') {
    const toast: any = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      customClass: { container: 'toast' },
    });
    toast.fire({
      icon: type,
      title: msg,
      padding: '10px 20px',
    });
  }
}
